import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EvaluationService } from 'app/assessment/evaluation/services/evaluation.service';
import { SurveyService } from 'app/assessment/survey/services/survey.service';
import { MaterialModule } from 'app/material.module';
import { HomeModule } from 'app/my-zone/home/home.module';
import { NotificationModule } from 'app/notifications/notification.module';
import { SharedModule } from 'app/shared/shared.module';
import { SiteFiltersModule } from 'app/site-filters/site-filters.module';
import { SiteLogoModule } from 'app/site-logo/site-logo.module';
import { TaskModule } from 'app/task/task.module';

import { AppLayoutRoutingModule, routedComponents } from './app-layout-routing.module';
import { AppErrorComponent } from './components/app-error/app-error.component';
import { ExtendLogoutDialogComponent } from './components/extend-logout-dialog/extend-logout-dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SidenavPrimaryComponent } from './components/sidenav-primary/sidenav-primary.component';
import { SidenavSecondaryComponent } from './components/sidenav-secondary/sidenav-secondary.component';
import { ReportsNavGuard } from './models/nav/nav-guards/reports-nav.guard';
import { NavItemsService } from './services/nav-items.service';
import { NavItemsEffectsService, navItemsReducer } from './state';

@NgModule({
  imports: [
    StoreModule.forFeature('navItems', navItemsReducer),
    EffectsModule.forFeature([
      NavItemsEffectsService,
    ]),
    CommonModule,
    RouterModule,
    MaterialModule,
    AppLayoutRoutingModule,
    HomeModule,
    TaskModule,
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    SiteFiltersModule,
    NotificationModule,
    SiteLogoModule,


  ],
  declarations: [
    routedComponents,
    AppErrorComponent,
    NotFoundComponent,
    SidenavPrimaryComponent,
    SidenavSecondaryComponent,
    HeaderComponent,
    FooterComponent,
    ExtendLogoutDialogComponent,

  ],
  entryComponents: [
    ExtendLogoutDialogComponent,
  ],
  exports: [
    routedComponents,
    AppErrorComponent,
    NotFoundComponent,
    SidenavPrimaryComponent,
    SidenavSecondaryComponent,
    HeaderComponent,
    FooterComponent,
    ExtendLogoutDialogComponent,
  ],
  providers: [
    NavItemsService,
    NavItemsEffectsService,
    SurveyService, // needed because AppLayoutComponent has this service as a DI constructor param
    EvaluationService,
    ReportsNavGuard,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class AppLayoutModule {}
